// 详情模块

const Code = {
  namespaced: true,

  state: {
    hasUploadFile: false,
    uploadNoSend: false,
    showUploadDialog: false,
    actionContinue: false
  },
  mutations: {
    SET_UPLOAD_FILE_STATUS: (state, value) => {
      state.hasUploadFile = value
    },
    SET_UPLOAD_NO_SEND_STATUS: (state, value) => {
      state.uploadNoSend = value
    },
    SET_UPLOAD_DIALOG_STATUS: (state, value) => {
      state.showUploadDialog = value
    }
  },
  actions: {}
}

export default Code
